
const Awards = () => {
  const awards = [
    {
      image: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/421a5baeffda80df144cad0033823d3d.jpeg",
      title: "Meilleur Traiteur de l'Année"
    },
    {
      image: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/421a5baeffda80df144cad0033823d3d.jpeg",
      title: "Excellence Culinaire"
    },
    {
      image: "https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/421a5baeffda80df144cad0033823d3d.jpeg",
      title: "Service d'Exception"
    }
  ];

  return (
    <section id="recompenses" className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-300 mb-8" style={{ fontFamily: 'Alice, serif' }}>
            Nos Distinctions
          </h2>
          
          <div className="flex items-center justify-center mb-8">
            <div className="w-24 h-px bg-gray-300"></div>
            <div className="w-4 h-4 bg-gray-300 rounded-full mx-6 rotate-45"></div>
            <div className="w-24 h-px bg-gray-300"></div>
          </div>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Reconnus pour notre excellence, nous sommes fiers de ces distinctions qui témoignent de notre engagement
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {/* Premier badge */}
          <div className="text-center">
            <div className="mb-6 flex justify-center">
              <img 
                src="https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/421a5baeffda80df144cad0033823d3d.jpeg"
                alt="Wedding Awards 2019"
                className="w-40 h-48 object-contain"
              />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Meilleur Traiteur 2025</h3>
            <p className="text-gray-300">Wedding Awards Paris</p>
          </div>

          {/* Deuxième badge */}
          <div className="text-center">
            <div className="mb-6 flex justify-center">
              <img 
                src="https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/97fcc1f622ba456fc3c537ea297ae024.png"
                alt="Wedding Awards 2018"
                className="w-40 h-48 object-contain"
              />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Excellence Culinaire 2024</h3>
            <p className="text-gray-300">Wedding Awards Paris</p>
          </div>

          {/* Troisième badge */}
          <div className="text-center">
            <img
              src="https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/4ec2bb729b2d37b1d0e1ce28e5e99f8d.png"
              alt="Wedding Awards 2025"
              className="w-40 h-48 object-contain mx-auto mb-4"
            />
            <h4 className="text-white font-semibold text-lg mb-2" style={{ fontFamily: 'Alice, serif' }}>
              Innovation Gastronomique 2019
            </h4>
            <p className="text-gray-300 text-sm">
              Récompense pour l'innovation culinaire exceptionnelle
            </p>
          </div>

          {/* Quatrième badge - nouvelle image */}
          <div className="text-center">
            <div className="mb-6 flex justify-center">
              <img 
                src="https://static.readdy.ai/image/ad440e5983da10e2cbbc9a815800d393/8c9227b525657726439756cd43de1c93.png"
                alt="Wedding Awards 2017"
                className="w-40 h-48 object-contain"
              />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Service Premium 2017</h3>
            <p className="text-gray-300">Wedding Awards Paris</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Awards;
